<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">{{ $t("enterBankDetails") }}</h1>
                <bank-account-details-form
                    :validation="validation"
                    @submit="onSubmit"
                />
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import BankAccountDetailsForm from '@product-common/components/investor/BankAccountDetailsForm';
import ProfileHeader from '@investor/components/profile/ProfileHeader';

export default {
        components: {
            ProfileHeader,
            BankAccountDetailsForm,
        },
        data() {
            return {
                validation: {
                    fieldErrors: {}
                }
            };
        },
        methods: {
            async onSubmit(form) {
                this.validation = {
                    fieldErrors: {}
                };
                try {
                    await this.$post('registration/bank-account-details', form);
                    await this.$fetchInvestorProfile();
                    await this.$routeInvestor();
                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        this.validation = error.response.data;
                        this.$scrollToErrorField();
                    }
                }
            }
        }
    };
</script>


